import React from "react";
import Typography from "components/Typography";
import classes from "./GoodsamInsuranceDesktopTableTd.module.css";
import cn from 'classnames';
import { tickDarkGreenIcon, closeIcon, explainerIconOutline } from "components/Icon";
import Tooltip from "components/Tooltip/Tooltip";
import { StringItem } from "components/StringItem";
import { BOOLEAN_VALUES } from "../../constants";

export const GoodsamInsuranceDesktopTableTd = (props) => {
  const {
    header,
    isGroupStart,
    isGroupEnd,
    isGroup,
    isPlan,
    tip,
    valueString
  } = props;

  return (
    <div
      className={cn(
        classes.container,
        isGroupStart && classes.groupStart,
        isGroupEnd && classes.groupEnd,
      )}
    >
      <div className={classes.containerInner}>
        <div className={classes.content}>
          {valueString === BOOLEAN_VALUES.TRUE ? (
            <div className={cn(classes.planContent, classes.trueIcon)}>
              {tickDarkGreenIcon}
            </div>
          ) : null}
          {valueString === BOOLEAN_VALUES.FALSE ? (
            <div className={cn(classes.planContent, classes.falseIcon)}>
              {closeIcon}
            </div>
          ) : null}

          {valueString !== BOOLEAN_VALUES.TRUE && valueString !== BOOLEAN_VALUES.FALSE ? (
            <div
              className={cn(
                isGroup && classes.groupContent,
                isPlan && classes.planContent,
              )}
            >
              <Typography
                variant={header ? 'subtitle' : 'body'}
                size={header ? 'm' : 'l'}
                className={classes.value}
              >
                {header || valueString}
              </Typography>

              {tip ? (
                <span
                  className={classes.tipButton}
                >
                  <Tooltip
                    tooltipContainerClassName={classes.tip}
                    tooltipContent={<div dangerouslySetInnerHTML={{ __html: tip }} />}
                    offset={[12, 12]}
                    placement="right"
                  >
                    {(ref) => (
                      <span ref={ref} className={classes.tipIcon}>
                        {explainerIconOutline}
                      </span>
                    )}
                  </Tooltip>
                </span>
              ) : null}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};
